import Alpine from 'alpinejs';

import collapse from '@alpinejs/collapse'
import VideoSlider from './modules/videoSlider';

// Utilities
import http from './utils/http';
import alpineModules from './utils/alpine-modules';

// Alpine Components
import cart from './store/cart';

// Global
window.Alpine = Alpine;
window.http = http;

// Plugins
Alpine.plugin(alpineModules);
Alpine.plugin(collapse);

// Stores
Alpine.store('cart', cart);

// Inits
Alpine.start();

document.querySelectorAll('[data-video-slider]').forEach((el) => {
  new VideoSlider(el);
});
